import { j as l } from "../../jsx-runtime-BwWtxLpl.js";
import { useRef as d, useEffect as v } from "react";
import x from "classnames";
const N = ({
  src: e = "",
  className: i = "",
  title: c = "",
  iconFunction: r = () => ({}),
  strokeWidth: s = "1.5px",
  stroke: a = "currentColor",
  fill: m = "none",
  size: f = "16",
  ...g
}) => {
  const u = x({
    "motif-icon": !0,
    [i]: i
  }), n = d(null);
  return v(() => {
    (async () => {
      let t;
      if (typeof e == "function")
        t = e({ strokeWidth: s, stroke: a, fill: m, size: f });
      else if (typeof e == "string") {
        if (e.startsWith("data:image/svg+xml;base64,")) {
          const o = atob(e.replace("data:image/svg+xml;base64,", ""));
          t = new DOMParser().parseFromString(o, "image/svg+xml").documentElement;
        } else if (e.startsWith("<svg")) {
          const p = new DOMParser().parseFromString(e, "image/svg+xml");
          t = document.importNode(p.documentElement, !0);
        }
      } else
        typeof e == "object" && e !== null && (t = e);
      if (!e && typeof r == "function" && (t = r({ strokeWidth: s, stroke: a, fill: m, size: f })), n.current)
        if (n.current.innerHTML = "", t instanceof Node)
          n.current.appendChild(t);
        else {
          const o = document.createElementNS("http://www.w3.org/2000/svg", "svg");
          o.innerHTML = t, n.current.appendChild(o);
        }
    })();
  }, [e, r, s, a, m, f]), /* @__PURE__ */ l.jsx("span", { className: u, ref: n, title: c, ...g, "data-motif-icon": !0 });
};
export {
  N as MotifIcon
};
